import React, { useCallback } from "react";
import { history } from "../../redux-store/store";
import { connect } from "react-redux";
import { CanI } from "../../redux-store/action/permissions/permissions";
import LegacyTypeahead from "@comps/Typeahead";
import {
  AddressBookTabsIcon,
  CarIcon,
  HouseLineIcon,
  InvoiceIcon,
  KeyIcon,
  ReceiptIcon,
  UserIcon,
} from "@phosphor-icons/react";

const RESULT_ICONS = {
  automobiles: CarIcon,
  contacts: UserIcon,
  invoices: InvoiceIcon,
  leases: KeyIcon,
  properties: HouseLineIcon,
  vendor_bills: ReceiptIcon,
  vendors: AddressBookTabsIcon,
};

const TypeAhead = ({ component, CanI }) => {
  const getSearchUrl = useCallback(
    query => `/${component}/typeToSearch?search=${encodeURIComponent(query)}`,
    [component]
  );

  const handleOnSelect = useCallback(async option => {
    const verb = (await CanI(`${component}_edit`)) ? "edit" : "view";

    let prefix;
    if (history.location.pathname.startsWith("/app")) {
      prefix = "/app";
    }
    openSearchResult({
      prefix,
      component,
      verb,
      value: option.value
    });
  }, [CanI, component]);

  return (
    <LegacyTypeahead
      className="navbar-typeahead"
      debounceMs={1000}
      dropdownWidth={600}
      name={"search_query"}
      onSelect={handleOnSelect}
      placeholder="Type to Search"
      resultIcon={RESULT_ICONS[component]}
      searchUrl={getSearchUrl}
    />
  );
};
export default connect(null, { CanI })(TypeAhead);

function openSearchResult({ prefix, component, verb, value }) {
  if (prefix) {
    window.location.href = `${prefix}/${component}/${verb}/${value}`;
  } else {
    window.location.href = `/${component}/${verb}/${value}`;
  }
}
